import React from "react";

import { CopyField } from "components/fields/CopyField";
import { ValueChip } from "components/fields/ValueChip";

export const ValueChipWithType = ({ value, link, typeLabel }) => {
	const content = (
		<>
			<ValueChip value={value} link={link} />
			{typeLabel && <span>{typeLabel}</span>}
		</>
	);

	if (value) {
		return (
			<CopyField value={value} copyByIcon>
				{content}
			</CopyField>
		);
	}

	return <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>{content}</span>;
};
